import { SessionGetResponseSession } from '@/dtos/ideas/admin-idea/commons'
import { Type } from 'class-transformer'

export class AdminIdeaSessionPutRequest {
  ideaId!: string
  @Type(() => SessionGetResponseSession)sessions: SessionGetResponseSession[] = []
  version!: number
}
